import config from "@/constants/config";

type WhiteLabelImageResult = (imgURL: string) => string;

const replaceWhiteLabelTokens = (imgURL: string): string => {
  return imgURL
    .replaceAll("%tenantKey%", config.tenantConfig.key)
    .replaceAll("%tenantLocation%", config.tenantConfig.location);
};

export const useWhiteLabelImage = (): WhiteLabelImageResult => {
  return replaceWhiteLabelTokens;
};
